import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonToggleModule } from '@angular/material/button-toggle';

import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';

import { MatBadgeModule } from '@angular/material/badge';
import { SiteListComponent } from './components/site-list/site-list.component';
import { MatTreeModule } from '@angular/material/tree';
import { MatChipsModule } from '@angular/material/chips';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import {
  SiteDetailsPanelComponent
} from './site-details-panel/site-details-panel.component';
import {
  SiteListHeaderComponent
} from './components/site-list-header/site-list-header.component';
import { SiteCardComponent } from './components/site-card/site-card.component';
import { SiteFiltersPanelComponent } from './site-filters-panel/site-filters-panel.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSliderModule } from '@angular/material/slider';
import { MatTabsModule } from '@angular/material/tabs';
import { TranslocoModule } from '@jsverse/transloco';
import {
  SiteActionsBarComponent
} from './components/site-actions-bar/site-actions-bar.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import {
  SiteListPanelComponent
} from './site-list-panel/site-list-panel.component';
import {
  SiteSettingsDialogComponent
} from './components/site-settings-dialog/site-settings-dialog.component';



@NgModule({
  declarations: [
    SiteListComponent,
    SiteListHeaderComponent,
    SiteCardComponent,
    SiteDetailsPanelComponent,
    SiteFiltersPanelComponent,
    SiteListPanelComponent,
    SiteActionsBarComponent,
    SiteSettingsDialogComponent,
  ],
  exports: [
    SiteDetailsPanelComponent,
    SiteFiltersPanelComponent,
    SiteListPanelComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    MatFormFieldModule,
    MatButtonModule,
    MatIconModule,
    MatPaginatorModule,
    MatTableModule,
    MatSortModule,
    MatTooltipModule,
    MatDialogModule,
    MatExpansionModule,
    MatInputModule,
    MatButtonToggleModule,
    MatListModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatCardModule,
    MatBadgeModule,
    ReactiveFormsModule,
    MatTreeModule,
    MatChipsModule,
    MatMenuModule,
    MatToolbarModule,
    MatCheckboxModule,
    MatSliderModule,
    MatTabsModule,
    TranslocoModule,
    MatSlideToggleModule
  ]
})
export class SiteModule {}
